import React, { useState, useEffect } from 'react'
import Dashboard from '../components/spotDashboard/Dashboard'
import CounsellingPayment from './CounsellingPayment'
import Message from './Message'
import axios from 'axios'
import Spinner from './Spinner'
import CollegeChoice from './ChoiceFilling'
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Button from '@mui/material/Button';
import { useNavigate } from 'react-router-dom'



function Home() {
  const [data, setData] = useState({})
  const [spin, setSpin] = useState(false)
  const [open, setOpen] = React.useState(true);
  const [paymentStatus, setPaymentStatus] = useState()
  const navigate = useNavigate()
  const getData = () => {
    setOpen(true)
    axios.get('/api/v1/front/user/profile')
      .then(function (response) {
        // handle success
        setOpen(false)
        if (response.data && response.data.data) {
          const profileData = response.data.data;
          setData(profileData)
          
          // Note: sample response doesn't show college_choice, but checking if it exists
          if (profileData.counsellingPayment) {
            setPaymentStatus(profileData.counsellingPayment.payment_status)
          } else {
            setPaymentStatus(false)
          }

          if (profileData.college_choice && profileData.college_choice.length >= 1) {
            const collegeChoice = profileData.college_choice[0];

            if (collegeChoice.college_submit === 'yes') {
              navigate('/student/thank-you-for-participating-college-choice')
            }

            if (collegeChoice.is_college_locked == true ||
                (collegeChoice.round_one_action == 'Freeze' || 
                 collegeChoice.round_two_action == 'Freeze' || 
                 collegeChoice.round_three_action == "Freeze" || 
                 collegeChoice.all_round_three == true)
            ) {
              navigate('/student/dashboard/seat-confirmation')
            }
          }

        } else {
          console.error("User data not found in response");
          setPaymentStatus(false)
        }

        console.log(response.data.data)
      })
      .catch(function (error) {
        // handle error
        setOpen(false)
        console.log(error);
      })
  }


  const handleClose = () => {
    setOpen(false);
  };
  const handleToggle = () => {
    setOpen(!open);
  };
  useEffect(() => {
    getData()
  }, [])
  return (
    <div>
      <Dashboard />
      {
        open == false && <>

          {
            paymentStatus ? <CollegeChoice /> : <CounsellingPayment />
          }
        </>
      }

      <div>

        <Backdrop
          sx={{ color: '#0e2e2e', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={open}
          style={{ backgroundColor: 'white' }}
        // onClick={handleClose}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>
    </div>
  )
}

export default Home
